const COOKIE_NAME = 'p2w_home'
const MAX_AGE_SECONDS = 90 * 24 * 60 * 60

function getParentDomain() {
  const parts = window.location.hostname.split('.')

  return '.' + parts.slice(-2).join('.')
}

function buildCookie(parts) {
  if (window.location.protocol === 'https:') {
    parts.push('secure')
  }

  return parts.join('; ')
}

export function setHomeAppCookie(isEmployee) {
  const home = isEmployee ? 'crm' : 'app'
  const domain = getParentDomain()

  document.cookie = buildCookie([
    `${COOKIE_NAME}=${home}`,
    `domain=${domain}`,
    'path=/',
    `max-age=${MAX_AGE_SECONDS}`,
    'samesite=lax',
  ])
}

export function getHomeApp() {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=(crm|app)`))

  return match ? match[1] : null
}

function getAllDomainVariants() {
  const host = window.location.hostname
  const parts = host.split('.')
  const variants = new Set([null, host, `.${host}`])

  for (let segmentStart = 0; segmentStart < parts.length - 1; segmentStart++) {
    const suffix = parts.slice(segmentStart).join('.')
    variants.add(suffix)
    variants.add(`.${suffix}`)
  }

  return [...variants]
}

function getAllPathVariants() {
  const pathname = window.location.pathname
  const segments = pathname.split('/').filter(Boolean)
  const variants = new Set(['/'])
  let accumulated = ''

  for (const segment of segments) {
    accumulated += `/${segment}`
    variants.add(accumulated)
  }

  return [...variants]
}

export function clearHomeAppCookie() {
  const domainVariants = getAllDomainVariants()
  const pathVariants = getAllPathVariants()
  const expiredAttrs = ['max-age=0', 'expires=Thu, 01 Jan 1970 00:00:00 GMT']

  for (const domain of domainVariants) {
    for (const path of pathVariants) {
      const parts = [`${COOKIE_NAME}=`, `path=${path}`, ...expiredAttrs, 'samesite=lax']
      if (domain) {
        parts.push(`domain=${domain}`)
      }
      document.cookie = buildCookie(parts)
    }
  }
}
